import { useNavigate } from 'react-router-dom';
import Footer from '@/pages/home/components/Footer';
import { mainSiteUrl, categories } from '@/mocks/categories';

export default function ArticlePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50">
      <nav className="fixed top-0 left-0 w-full z-50 bg-white shadow-sm">
        <div className="w-full px-6 md:px-10">
          <div className="flex items-center justify-between h-[72px]">
            <a
              href="/"
              onClick={(e) => { e.preventDefault(); navigate('/'); }}
              className="flex items-center gap-2 whitespace-nowrap cursor-pointer text-foreground-950"
            >
              <span className="font-heading text-xl md:text-2xl font-bold tracking-tight">
                Itaobuy Spreadsheet
              </span>
            </a>
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate('/')}
                className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-left-line"></i>
                Torna alla Home
              </button>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                itaobuy sheet
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </nav>

      <main>
        <section className="relative w-full min-h-[350px] md:min-h-[440px] flex items-center overflow-hidden pt-[72px]">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20minimalist%20workspace%20with%20laptop%20displaying%20organized%20product%20data%20spreadsheet%2C%20warm%20cream%20desk%2C%20natural%20daylight%20from%20window%2C%20coffee%20cup%2C%20plants%2C%20italian%20modern%20interior%2C%20professional%20editorial%20photography%2C%20soft%20ambient%20light%2C%20clean%20productive%20atmosphere&width=1800&height=900&seq=itaobuy-article-hero-v2&orientation=landscape')`,
            }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

          <div className="relative z-10 w-full px-6 md:px-10 lg:px-20 py-16">
            <div className="max-w-[720px]">
              <span className="inline-block px-3 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white/90 text-xs font-semibold mb-6">
                Guida Completa 2026
              </span>
              <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
                Guida Completa a Itaobuy Spreadsheet: Come Funziona, Categorie e Consigli 2026
              </h1>
              <p className="text-white/65 text-base md:text-lg leading-relaxed">
                Tutto quello che devi sapere su <strong className="text-white/90">itaobuy spreadsheet</strong>:
                come utilizzarlo, quali categorie sono disponibili, consigli pratici e informazioni sulla sicurezza.
              </p>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-100">
          <article className="max-w-[820px] mx-auto px-6 md:px-10">
            <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-white border border-background-200 mb-8">
              <span className="text-foreground-600 text-sm font-semibold">Analisi SEO</span>
            </div>

            <div className="prose-custom space-y-8">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  Cos&apos;&egrave; Itaobuy Spreadsheet e Perch&eacute; Sta Diventando Cos&igrave; Popolare in Italia
                </h2>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  Negli ultimi anni, <strong>itaobuy spreadsheet</strong> &egrave; emerso come uno degli strumenti
                  pi&ugrave; discussi tra gli appassionati di shopping online in Italia. Si tratta di un sistema
                  organizzato di fogli di calcolo che raccoglie, cataloga e presenta prodotti selezionati
                  da diverse categorie merceologiche. La sua popolarit&agrave; deriva dalla capacit&agrave; di
                  semplificare enormemente il processo di ricerca prodotti, permettendo agli utenti di
                  risparmiare ore di navigazione su molteplici piattaforme.
                </p>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  Ma cosa rende <strong>itaobuy spreadsheet</strong> cos&igrave; speciale? La risposta sta nella
                  sua struttura. Ogni foglio &egrave; organizzato per categoria, con colonne dedicate a prezzo,
                  valutazione del venditore, qualit&agrave; del prodotto, tempi di spedizione e note aggiuntive.
                  Questo livello di dettaglio permette confronti rapidi e decisioni informate, eliminando
                  la necessit&agrave; di aprire decine di schede del browser.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  Come Funziona Itaobuy Spreadsheet: Una Guida Passo Dopo Passo
                </h2>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  Utilizzare <strong>itaobuy spreadsheet</strong> &egrave; sorprendentemente semplice,
                  anche per chi non ha familiarit&agrave; con strumenti di organizzazione dati. Ecco i tre
                  passaggi fondamentali per iniziare:
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 my-8">
                  {[
                    { step: '01', title: 'Trova', desc: 'Cerca la categoria o il prodotto che ti interessa dal menu a tendina o dai pulsanti categoria.' },
                    { step: '02', title: 'Analizza', desc: 'Controlla informazioni, prezzi e valutazioni per confrontare le opzioni disponibili.' },
                    { step: '03', title: 'Decidi', desc: 'Scegli il prodotto pi\u00f9 adatto alle tue esigenze con dati chiari e organizzati.' },
                  ].map((s, i) => (
                    <div key={i} className="bg-white rounded-2xl p-6 border border-background-200">
                      <span className="font-heading text-3xl font-bold text-accent-400">{s.step}</span>
                      <h3 className="font-heading text-lg font-semibold text-foreground-950 mt-2 mb-2">{s.title}</h3>
                      <p className="text-foreground-500 text-sm leading-relaxed">{s.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  Tutte le Categorie Disponibili su Itaobuy Spreadsheet
                </h2>
                <p className="text-foreground-600 leading-relaxed mb-6">
                  Una delle caratteristiche pi&ugrave; apprezzate di <strong>itaobuy spreadsheet</strong> &egrave;
                  l&apos;ampia copertura di categorie. Attualmente sono disponibili 14 categorie principali,
                  ciascuna con centinaia di prodotti selezionati:
                </p>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
                  {categories.map((cat) => (
                    <a
                      key={cat.id}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-2 px-4 py-3 rounded-xl bg-white border border-background-200 text-sm text-foreground-700 hover:border-accent-300 hover:text-accent-700 transition-all cursor-pointer"
                    >
                      <i className="ri-arrow-right-up-line text-accent-500 text-xs"></i>
                      {cat.nameIt}
                    </a>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  Vantaggi di Utilizzare Itaobuy Spreadsheet
                </h2>
                <div className="overflow-x-auto mb-8">
                  <table className="w-full border-collapse bg-white rounded-2xl overflow-hidden border border-background-200">
                    <thead>
                      <tr className="bg-background-100">
                        <th className="text-left px-5 py-4 font-semibold text-foreground-700 text-sm">Vantaggio</th>
                        <th className="text-left px-5 py-4 font-semibold text-foreground-700 text-sm">Descrizione</th>
                        <th className="text-left px-5 py-4 font-semibold text-foreground-700 text-sm">Impatto</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ['Risparmio di Tempo', 'Riduce drasticamente il tempo di ricerca prodotti', 'Alto'],
                        ['Dati Organizzati', 'Informazioni strutturate e facili da consultare', 'Alto'],
                        ['Confronto Rapido', 'Confronta prezzi e caratteristiche istantaneamente', 'Medio'],
                        ['Accesso Gratuito', 'Nessun costo per accedere agli spreadsheet', 'Alto'],
                        ['Aggiornamenti Regolari', 'Dati mantenuti aggiornati periodicamente', 'Medio'],
                      ].map((row, i) => (
                        <tr key={i} className="border-b border-background-200 last:border-b-0">
                          <td className="px-5 py-4 text-sm font-semibold text-foreground-950">{row[0]}</td>
                          <td className="px-5 py-4 text-sm text-foreground-600">{row[1]}</td>
                          <td className="px-5 py-4">
                            <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-semibold ${row[2] === 'Alto' ? 'bg-accent-100 text-accent-700' : 'bg-background-100 text-foreground-600'}`}>
                              {row[2]}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  Itaobuy Spreadsheet &egrave; Sicuro? La Nostra Analisi
                </h2>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  La sicurezza &egrave; una preoccupazione legittima quando si utilizzano strumenti di terze parti.
                  Per quanto riguarda <strong>itaobuy spreadsheet</strong>, &egrave; importante sottolineare che
                  si tratta di uno strumento informativo. Non richiede dati personali, non effettua transazioni
                  e non memorizza informazioni sensibili degli utenti.
                </p>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  Tuttavia, &egrave; sempre consigliabile verificare personalmente i dettagli dei prodotti
                  e dei venditori prima di effettuare qualsiasi acquisto. Itaobuy Spreadsheet fornisce
                  un punto di partenza organizzato, ma la decisione finale e la due diligence spettano
                  sempre all&apos;utente.
                </p>
                <div className="bg-white rounded-2xl border border-background-200 p-6 my-6">
                  <p className="text-foreground-500 text-sm italic leading-relaxed">
                    <i className="ri-information-line text-accent-500 mr-1"></i>
                    Le informazioni presenti in questo articolo hanno scopo informativo. Prima di effettuare
                    qualsiasi acquisto, verificare sempre dettagli, condizioni e informazioni aggiornate
                    direttamente sulla piattaforma.
                  </p>
                </div>
              </div>

              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  Consigli Pratici per Ottenere il Massimo da Itaobuy Spreadsheet
                </h2>
                <ul className="space-y-3">
                  {[
                    'Esplora tutte le categorie prima di concentrarti su una specifica: potresti scoprire alternative interessanti.',
                    'Utilizza i filtri di ordinamento per prezzo e valutazione per trovare rapidamente le migliori opzioni.',
                    'Confronta sempre almeno 3-4 prodotti simili prima di prendere una decisione.',
                    'Tieni d\'occhio gli aggiornamenti: nuovi prodotti vengono aggiunti regolarmente.',
                    'Combina le informazioni dello spreadsheet con una ricerca personale per una valutazione completa.',
                  ].map((tip, i) => (
                    <li key={i} className="flex gap-3 text-foreground-600 text-sm leading-relaxed">
                      <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 text-xs font-bold flex-shrink-0 mt-0.5">
                        {i + 1}
                      </span>
                      {tip}
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  Domande Frequenti su Itaobuy Spreadsheet
                </h2>
                <div className="space-y-3">
                  {[
                    { q: "Itaobuy Spreadsheet \u00e8 disponibile in italiano?", a: "S\u00ec, questa guida e tutte le risorse collegate sono in italiano. Le categorie e le descrizioni sono state tradotte per il pubblico italiano." },
                    { q: "Devo registrarmi per usare Itaobuy Spreadsheet?", a: "No, non \u00e8 richiesta alcuna registrazione. Puoi accedere liberamente a tutte le categorie e ai prodotti elencati." },
                    { q: "Con quale frequenza vengono aggiornati i dati?", a: "I dati vengono aggiornati periodicamente. La versione attuale \u00e8 aggiornata al 2026 con le informazioni pi\u00f9 recenti." },
                    { q: "Posso suggerire nuove categorie di prodotti?", a: "Le categorie attuali coprono le principali aree di interesse. Per richieste specifiche, visita il sito principale." },
                  ].map((faq, i) => (
                    <details key={i} className="group bg-white rounded-2xl border border-background-200 overflow-hidden">
                      <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                        <span className="font-semibold text-foreground-950 text-sm pr-4">{faq.q}</span>
                        <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-background-100 group-open:bg-accent-100 transition-colors">
                          <i className="ri-add-line text-foreground-500 text-sm group-open:hidden"></i>
                          <i className="ri-subtract-line text-accent-600 text-sm hidden group-open:block"></i>
                        </span>
                      </summary>
                      <div className="px-5 pb-4">
                        <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            </div>
          </article>
        </section>

        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-[800px] mx-auto text-center px-6 md:px-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              Pronto a Scoprire Itaobuy Spreadsheet?
            </h2>
            <p className="text-foreground-500 text-base mb-8 max-w-[500px] mx-auto">
              Visita ora la piattaforma completa ed esplora tutte le categorie di prodotti disponibili.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                Visita itaobuy sheet now
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <button
                onClick={() => navigate('/')}
                className="flex items-center gap-2 px-8 py-4 rounded-full bg-background-100 text-foreground-700 font-semibold text-base hover:bg-background-200 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-home-line"></i>
                Torna alla Home
              </button>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: 'Guida Completa a Itaobuy Spreadsheet: Come Funziona, Categorie e Consigli 2026',
            description: 'Tutto quello che devi sapere su itaobuy spreadsheet: come utilizzarlo, quali categorie sono disponibili, consigli pratici e informazioni sulla sicurezza.',
            datePublished: '2026-07-14',
            dateModified: '2026-07-14',
            inLanguage: 'it',
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': `${import.meta.env.VITE_SITE_URL}/articolo-guida-itaobuy-spreadsheet`,
            },
            author: {
              '@type': 'Organization',
              name: 'Itaobuy Spreadsheet Italia',
            },
            publisher: {
              '@type': 'Organization',
              name: 'Itaobuy Spreadsheet Italia',
              logo: {
                '@type': 'ImageObject',
                url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg',
              },
            },
          }),
        }}
      />
    </div>
  );
}